var map = {
	"./cs/main2.yml": 76,
	"./da/main2.yml": 77,
	"./de/main2.yml": 78,
	"./el/main2.yml": 79,
	"./en/main2.yml": 80,
	"./eo/main2.yml": 81,
	"./es/main2.yml": 82,
	"./fi/main2.yml": 83,
	"./fr/main2.yml": 84,
	"./gd/main2.yml": 85,
	"./gl/main2.yml": 86,
	"./id/main2.yml": 87,
	"./it/main2.yml": 88,
	"./pl/main2.yml": 89,
	"./ru/main2.yml": 90,
	"./si/main2.yml": 91,
	"./tr/main2.yml": 92
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 212;